import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import PlayButton from '../containers/PlayButton';
import styles from './PreviewScreen.module.css';
export default function PreviewScreen(_a) {
    var imageURL = _a.imageURL, imageWidth = _a.imageWidth, imageHeight = _a.imageHeight;
    var stretchedImageWidth = Math.ceil(imageWidth);
    var stretchedImageHeight = Math.ceil(imageHeight);
    return (React.createElement("div", { className: cx(styles.preview, 'position-absolute pinAll'), style: {
            backgroundImage: "url(" + imageURL + ")",
            backgroundSize: stretchedImageWidth + "px " + stretchedImageHeight + "px",
            backgroundPosition: '50% 0',
        } },
        React.createElement(PlayButton, null)));
}
PreviewScreen.propTypes = {
    imageURL: PropTypes.string.isRequired,
    imageWidth: PropTypes.number.isRequired,
    imageHeight: PropTypes.number.isRequired,
};
